import React, { PropTypes } from 'react';
import Item from 'common/components/entry_gallery/item';

const COLUMNS_MAP = {
  "default": [
    { title: "Name" },
    { title: "Creative", classes: "hide-for-small-only" },
    { title: "Submitted", classes: "hide-for-small-only" },
    { title: "Score" },
    {},
  ],
  "profileEntries": [
    { title: "Name" },
    { title: "Project", classes: "hide-for-small-only" },
    { title: "Submitted", classes: "hide-for-small-only" },
    { title: "Score" },
  ],
  "projectEntries": [
    { title: "Name" },
    { title: "Creative", classes: "hide-for-small-only" },
    { title: "Submitted", classes: "hide-for-small-only" },
    { title: "Score" },
    { title: "", classes: "hide-for-small-only" },
    {},
  ],
};

const NameDense = ({ items, itemVariation, ...otherProps }) => {
  const columns = COLUMNS_MAP[itemVariation] || COLUMNS_MAP["default"];

  return (
    <table className="table table-default named-entry-table">
      <thead>
        <tr>
          { columns.map((column, i) => <td key={i} className={column.classes}>{ column.title }</td>) }
        </tr>
      </thead>
      <tbody>
        { items.map((item, i) => (
        <Item key={i} item={item} variation={itemVariation} {...otherProps} />
        )) }
      </tbody>
    </table>
  );
}

NameDense.propTypes = {
  items: PropTypes.array.isRequired,
  itemVariation: PropTypes.string.isRequired,
};

export default NameDense;



// WEBPACK FOOTER //
// ./common/components/entry_gallery/name_dense.jsx